import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/custodyInvestments'
import { getCustodyInvestments as getCustodyInvestmentsService } from 'services'
import HTTP_STATUS from 'utils/statusCode'

const {
  CUSTODY_INVESTMENTS_REQUEST,
  CUSTODY_INVESTMENTS_SUCCESS,
  CUSTODY_INVESTMENTS_ERROR
} = ACTION_TYPES

export function *getCustodyInvestments() {
  try {
    const response = yield call(getCustodyInvestmentsService)
    yield put({ type: CUSTODY_INVESTMENTS_SUCCESS, payload: response })
  } catch (err) {
    const { response = {} } = Object(err)
    ![
      HTTP_STATUS.INTERNAL_SERVER_ERROR,
      HTTP_STATUS.UNAUTHORIZED,
      HTTP_STATUS.UNSUPPORTED_MEDIA_TYPE
    ].includes(response.status)
    && (yield put({ type: CUSTODY_INVESTMENTS_ERROR, payload: response }))
  }
}

export default function *watchCustodyInvestments() {
  yield takeLatest(CUSTODY_INVESTMENTS_REQUEST, getCustodyInvestments)
}
